import classNames from 'classnames';
import React from 'react';
import InputError from 'layout/atoms/InputError/InputError';
import InputLabel from 'layout/atoms/InputLabel/InputLabel';
import styles from './FormField.module.scss';
function FormField({ label, error, htmlFor, direction = 'column', labelWidth = 160, children, }) {
    if (direction === 'row') {
        return (React.createElement("div", { className: classNames(styles.wrap, styles.row) },
            React.createElement("div", { className: styles.labelCol, style: { width: `${labelWidth}px` } },
                React.createElement(InputLabel, { text: label, htmlFor: htmlFor }),
                React.createElement(InputError, { message: error })),
            React.createElement("div", { className: styles.inputCol }, children)));
    }
    return (React.createElement("div", { className: styles.wrap },
        React.createElement(InputLabel, { text: label, htmlFor: htmlFor }),
        children,
        React.createElement(InputError, { message: error })));
}
export default FormField;
